// Base/master fridge schema templates managed in Salesforce. New fridge schemas
// are copied from these, so a base template has no Location of its own and no
// live fridge carries its id — it would otherwise be filtered out of the schema
// tools as "not live". Keep these visible and editable so item/price changes can
// reach the masters that future copies inherit.
//
// Keep base schemas pinned to defaultSleepScreen. Reassigning one to a specific
// sleep screen makes every fridge later copied from it inherit that frozen
// screen, so a future change to the default leaves those copies stranded.
//
// Never delete these rows.
export const BASE_SCHEMA_IDS = new Set([
  // Midwest
  'MW_STANDARD_PLUS_3PERC',
  'MW_STANDARD_PLUS_3PERC_FULLY_SUBSIDIZED',
  'MW_STANDARD_PLUS_3PERC_E_S20',
  'MW_STANDARD_PLUS_3PERC_E_S25',
  'MW_STANDARD_PLUS_3PERC_E_S30',
  'MW_STANDARD_PLUS_3PERC_E_S50',
  'MW_STANDARD_PLUS_3PERC_E_S75',
  'MW_STANDARD_3PERC_E30_WITH_ITEM_PRICES',
  // Northeast
  'NE_STANDARD_PLUS_3PERC',
  'NE_STANDARD_PLUS_3PERC_FULLY_SUBSIDIZED',
  'NE_STANDARD_PLUS_3PERC_E_S20',
  'NE_STANDARD_PLUS_3PERC_E_S25',
  'NE_STANDARD_PLUS_3PERC_E_S30',
  'NE_STANDARD_PLUS_3PERC_E_S50',
  'NE_STANDARD_PLUS_3PERC_E_S75',
  'NE_STANDARD_PLUS_3PERC_HIGH_E_30',
  // West
  'W_STANDARD_PLUS_3PERC',
  'W_STANDARD_PLUS_3PERC_FULLY_SUBSIDIZED',
  'W_STANDARD_PLUS_3PERC_E_S20',
  'W_STANDARD_PLUS_3PERC_E_S25',
  'W_STANDARD_PLUS_3PERC_E_S30',
  'W_STANDARD_PLUS_3PERC_E_S50',
  'W_STANDARD_PLUS_3PERC_E_S75',
  // Airport
  'AIRPORT_STANDARD',
  'AIRPORT_PLUS_3PERC_LOW_STANDARD',
  'AIRPORT_PLUS_3PERC_LOW_9.5P_MOBILE_DISCOUNT',
  'AIRPORT_202301_PLUS_3PERC_25P_MOBILE_DISCOUNT',
  'AIRPORT_202301_PLUS_6PERC_25P_MOBILE_DISCOUNT',
]);

// The standard-slot sleep screen base schemas should stay assigned to.
export const DEFAULT_SLEEP_SCREEN_ID = 'defaultSleepScreen';
